import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListagemRelatorioPrestacaoContas from "./components/ListagemRelatoriosPrestacaoContas";

function RelatorioPrestacaoContasPage() {
  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Relatório de prestação de contas",
      url: "/relatorios/financeiro/prestacao-de-contas",
    },
  ]);

  return (
    <>
      <Container>
        <ListagemRelatorioPrestacaoContas />
      </Container>
    </>
  );
}

export default RelatorioPrestacaoContasPage;
